import { render, staticRenderFns } from "./CreateCardBasic.vue?vue&type=template&id=04744d1e&"
import script from "./CreateCardBasic.vue?vue&type=script&lang=js&"
export * from "./CreateCardBasic.vue?vue&type=script&lang=js&"
import style0 from "./CreateCardBasic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports